import { connect } from 'react-redux'

import {
  selectAreAnyBusinessHoursSet,
  doBusinessHoursLoad,
  doBusinessHoursSave,
  selectBusinessHours,
} from 'ducks/reports/businessHours'

import { doToggleBusinessHours } from '../../actions'
import { selectAreBusinessHoursEnabled } from '../../selectors'
import BusinessHoursControlView from './BusinessHoursControlView'

const select = state => ({
  areAnyBusinessHoursSet: selectAreAnyBusinessHoursSet(state),
  areBusinessHoursEnabled: selectAreBusinessHoursEnabled(state),
  businessHours: selectBusinessHours(state),
})
const perform = {
  doToggleBusinessHours,
  doBusinessHoursLoad,
  doBusinessHoursSave,
}

export default connect(select, perform)(BusinessHoursControlView)
